import { ReportData } from '../types/reportTypes';

// Parse currency string to number
const parseCurrency = (value: string): number => {
  return parseFloat(value.replace(/[$,]/g, ''));
};

// Parse percentage string to number
const parsePercentage = (value: string): number => {
  return parseFloat(value.replace(/%/g, '')) / 100;
};

// Calculate the sum of an array of numbers
const sum = (numbers: number[]): number => {
  return numbers.reduce((total, num) => total + num, 0);
};

// Calculate the individual job data from the January CSV
const jobData = [
  {
    jobInfo: "212: Malcolm & Patricia Doying",
    leadSource: "Thumbtack",
    trade: "Attic Insulation",
    contractTotal: 6471.00,
    grossMarginPct: 0.6945,
    grossProfit: 4494.11,
    salesCommission: 647.10,
    salesManagerFee: 64.71,
    companyOH: 1003.01,
    netProfit: 2779.29
  },
  {
    jobInfo: "213: Gail Zimmerman",
    leadSource: "Google Organic Search",
    trade: "Attic Insulation",
    contractTotal: 3672.00,
    grossMarginPct: 0.5615,
    grossProfit: 2061.83,
    salesCommission: 257.04,
    salesManagerFee: 36.72,
    companyOH: 569.16,
    netProfit: 1198.91
  },
  {
    jobInfo: "210: Lee Michael & Kimber James",
    leadSource: "Thumbtack",
    trade: "Roofing",
    contractTotal: 18750.00,
    grossMarginPct: 0.5500,
    grossProfit: 10312.50,
    salesCommission: 1312.50,
    salesManagerFee: 187.50,
    companyOH: 2906.25,
    netProfit: 5906.25
  },
  {
    jobInfo: "218: Shirley Rogers",
    leadSource: "Homebuddy",
    trade: "Windows & Doors",
    contractTotal: 5872.00,
    grossMarginPct: 0.6000,
    grossProfit: 3523.20,
    salesCommission: 587.20,
    salesManagerFee: 58.72,
    companyOH: 910.16,
    netProfit: 1967.12
  },
  {
    jobInfo: "208: Joseph & Sharon Turner",
    leadSource: "Homebuddy",
    trade: "Windows & Doors",
    contractTotal: 3321.00,
    grossMarginPct: 0.4400,
    grossProfit: 1461.24,
    salesCommission: 132.84,
    salesManagerFee: 33.21,
    companyOH: 514.76,
    netProfit: 780.43
  },
  {
    jobInfo: "200: Karen Regalbuto-Earp",
    leadSource: "Suburban MD Spring Home Show",
    trade: "Windows & Doors",
    contractTotal: 6600.00,
    grossMarginPct: 0.5900,
    grossProfit: 3894.00,
    salesCommission: 462.00,
    salesManagerFee: 66.00,
    companyOH: 1023.00,
    netProfit: 2343.00
  },
  {
    jobInfo: "196: Daniel & Dareya Cohen",
    leadSource: "Thumbtack",
    trade: "Attic Insulation",
    contractTotal: 3621.00,
    grossMarginPct: 0.5300,
    grossProfit: 1919.13,
    salesCommission: 253.47,
    salesManagerFee: 36.21,
    companyOH: 561.26,
    netProfit: 1068.19
  },
  {
    jobInfo: "194: Stephen Greenberg",
    leadSource: "Google Paid Search",
    trade: "Gutters",
    contractTotal: 1717.00,
    grossMarginPct: 0.5900,
    grossProfit: 1013.03,
    salesCommission: 120.19,
    salesManagerFee: 17.17,
    companyOH: 266.14,
    netProfit: 609.53
  },
  {
    jobInfo: "202: Nacheshia & Margaret Pierce",
    leadSource: "Web to Lead Form",
    trade: "Roofing",
    contractTotal: 9449.90,
    grossMarginPct: 0.4900,
    grossProfit: 4630.45,
    salesCommission: 378.00,
    salesManagerFee: 94.50,
    companyOH: 1464.73,
    netProfit: 2693.22
  },
  {
    jobInfo: "201: Colette Green",
    leadSource: "Contractors Appointments",
    trade: "Windows & Doors",
    contractTotal: 5840.05,
    grossMarginPct: 0.4800,
    grossProfit: 2803.22,
    salesCommission: 233.60,
    salesManagerFee: 58.40,
    companyOH: 905.21,
    netProfit: 1606.01
  },
  {
    jobInfo: "Gazew Asege",
    leadSource: "Networx",
    trade: "Windows & Doors",
    contractTotal: 9972.00,
    grossMarginPct: 0.4756,
    grossProfit: 4742.68,
    salesCommission: 398.88,
    salesManagerFee: 99.72,
    companyOH: 1545.66,
    netProfit: 2698.42
  },
  {
    jobInfo: "198: Gary Bowser",
    leadSource: "Suburban MD Spring Home Show",
    trade: "Attic Insulation",
    contractTotal: 2700.00,
    grossMarginPct: 0.5600,
    grossProfit: 1512.00,
    salesCommission: 189.00,
    salesManagerFee: 27.00,
    companyOH: 418.50,
    netProfit: 877.50
  }
];

// Calculate totals
const totalContractValue = sum(jobData.map(job => job.contractTotal));
const totalGrossProfit = sum(jobData.map(job => job.grossProfit));
const totalSalesCommissions = sum(jobData.map(job => job.salesCommission));
const totalManagerFees = sum(jobData.map(job => job.salesManagerFee));
const totalCompanyOH = sum(jobData.map(job => job.companyOH));

// January 2025 data for the marketing report - based on CSV data
export const januaryData: ReportData = {
  kpis: {
    // Sum of all ad spends from the January CSV
    adSpend: 32745.43,
    
    // Sum of all contract totals from the January Sales CSV
    totalSales: totalContractValue,
    
    // Sum of all gross profits from the January Sales CSV
    grossProfit: totalGrossProfit,
    
    // Sum of all sales commissions
    salesCommissions: totalSalesCommissions,
    
    // Sum of all manager fees
    managerFees: totalManagerFees,
    
    // Company overhead 
    companyOH: totalCompanyOH,
    
    // Net profit calculation
    netProfit: totalGrossProfit - totalSalesCommissions - totalManagerFees - totalCompanyOH - 32745.43,
    
    // Net profit as percentage of total sales
    netProfitPercent: (totalGrossProfit - totalSalesCommissions - totalManagerFees - totalCompanyOH - 32745.43) / totalContractValue,
    
    // Gross profit as percentage of total sales
    grossProfitPercent: totalGrossProfit / totalContractValue
  },
  
  // Ad spend by lead source from January AdSpend CSV
  adSpendBySource: [
    { source: "Web to Lead Form (Roofing Calculator)", spend: 6880.00 },
    { source: "Contractor Appointment", spend: 4900.00 },
    { source: "Thumbtack", spend: 4200.00 },
    { source: "Google Organic", spend: 3500.00 },
    { source: "Networx", spend: 3358.00 },
    { source: "Angi", spend: 0.00 },
    { source: "HomeBuddy", spend: 2637.00 },
    { source: "Facebook / Meta Ads", spend: 2539.95 },
    { source: "Suburban MD Spring Home Show", spend: 1750.00 },
    { source: "Yelp", spend: 1080.00 },
    { source: "Google AdWords", spend: 712.66 },
    { source: "Google LSA", spend: 618.32 },
    { source: "BBB", spend: 300.00 },
    { source: "Porch", spend: 269.50 },
    { source: "Guild Quality", spend: 0.00 },
    { source: "Lead2Performance", spend: 0.00 },
    { source: "Spring Connect", spend: 0.00 }
  ],
  
  // Sales by lead source - aggregated from January Sales CSV
  salesBySource: [
    { source: "Thumbtack", totalSales: 28842.00, count: 3, grossProfit: 16726.24 },
    { source: "Homebuddy", totalSales: 9193.00, count: 2, grossProfit: 4984.44 },
    { source: "Networx", totalSales: 9972.00, count: 1, grossProfit: 4742.68 },
    { source: "Web to Lead Form", totalSales: 9449.90, count: 1, grossProfit: 4630.45 },
    { source: "Suburban MD Spring Home Show", totalSales: 9300.00, count: 2, grossProfit: 5406.00 },
    { source: "Contractors Appointments", totalSales: 5840.05, count: 1, grossProfit: 2803.22 },
    { source: "Google Organic Search", totalSales: 3672.00, count: 1, grossProfit: 2061.83 },
    { source: "Google Paid Search", totalSales: 1717.00, count: 1, grossProfit: 1013.03 }
  ],
  
  // Sales by trade - aggregated from January Sales CSV
  salesByTrade: [
    { trade: "Windows & Doors", totalSales: 31605.05, count: 5, grossProfit: 17424.34 },
    { trade: "Roofing", totalSales: 28199.90, count: 2, grossProfit: 14942.95 },
    { trade: "Attic Insulation", totalSales: 16464.00, count: 4, grossProfit: 9987.07 },
    { trade: "Gutters", totalSales: 1717.00, count: 1, grossProfit: 1013.03 }
  ],
  
  // Individual job data from January Sales CSV
  jobData: jobData,
  period: {
    month: 1, // January
    year: 2025
  }
};